var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 30.99V36L-.01 23.99l2.516-2.499 9.494 9.5ZM17.01 36H12l12.011 12.01 2.506-2.505L17.009 36Zm28.487-9.497L48 24 24 0l-2.503 2.503L30.98 12h-5.732l-6.62-6.614-2.506 2.503 4.122 4.122h-2.869v18.625H36V27.77l4.122 4.122 2.503-2.506L36 22.747v-5.732l9.497 9.488ZM13.253 10.747l-2.503 2.506 2.686 2.686 2.503-2.506-2.686-2.686Zm21.314 21.314-2.495 2.503 2.686 2.686 2.506-2.503-2.697-2.686ZM7.878 16.121l-2.503 2.504L12 25.253v-5.012l-4.122-4.12ZM27.756 36h-5.009l6.628 6.625 2.503-2.503L27.756 36Z",
    fill: "#FF6363"
  })));
};

export default SvgLogo;